import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { useSiteContent } from "@/context/SiteContentContext";

const highlights = [
  { icono: "ri-tools-line", texto: "Desarrollo personalizado" },
  { icono: "ri-palette-line", texto: "Diseño moderno" },
  { icono: "ri-building-2-line", texto: "Soluciones orientadas a negocios" },
  { icono: "ri-device-line", texto: "Experiencia multiplataforma" },
  { icono: "ri-plug-line", texto: "Integraciones" },
  { icono: "ri-flow-chart", texto: "Automatización" },
  { icono: "ri-headphone-line", texto: "Soporte tecnológico" },
];

export default function About() {
  const { sections, settings } = useSiteContent();
  const content = sections.about || {};

  const title = String(content.title || "Más que desarrollo. Creamos soluciones.");
  const subtitle = String(
    content.subtitle ||
      "MARK DIRECT COMPANY nace con una visión clara: ayudar a negocios y emprendedores a convertir sus ideas en herramientas digitales funcionales, modernas y escalables."
  );
  const mision = content.mision ? String(content.mision) : "";
  const vision = content.vision ? String(content.vision) : "";
  const tagline = String(settings.tagline || "Convertimos ideas en soluciones digitales.");
  const brand = String(settings.brand || "MARK DIRECT COMPANY");
  const brandDescription = String(
    settings.brand_description || "Soluciones digitales para negocios que quieren crecer."
  );

  return (
    <section id="nosotros" className="relative py-20 md:py-28 bg-background-100 overflow-hidden">
      <div className="absolute -top-24 -left-24 w-80 h-80 rounded-full bg-primary-500/10 blur-3xl" />
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal variant="left">
            <SectionHeading
              align="left"
              eyebrow="Sobre la marca"
              title={title}
              subtitle={subtitle}
            />
            <div className="mt-8 flex flex-wrap gap-2.5">
              {highlights.map((h) => (
                <span
                  key={h.texto}
                  className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700"
                >
                  <i className={`${h.icono} text-primary-500`} />
                  {h.texto}
                </span>
              ))}
            </div>
          </Reveal>

          <Reveal variant="right">
            <div className="relative">
              <div className="rounded-3xl border border-background-200 bg-background-50 p-8 md:p-10 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-br from-primary-100 to-accent-50 rounded-full -translate-y-1/2 translate-x-1/2" />
                <p className="text-3xl md:text-4xl font-bold text-foreground-950 leading-tight relative">
                  "
                  <span className="bg-gradient-to-r from-primary-500 to-accent-500 bg-clip-text text-transparent">
                    {tagline}
                  </span>
                  "
                </p>

                <div className="mt-6 space-y-4 relative">
                  {mision && (
                    <div>
                      <p className="text-xs font-semibold uppercase tracking-wider text-primary-600 mb-1">
                        Misión
                      </p>
                      <p className="text-sm text-foreground-600 leading-relaxed">{mision}</p>
                    </div>
                  )}
                  {vision && (
                    <div>
                      <p className="text-xs font-semibold uppercase tracking-wider text-accent-600 mb-1">
                        Visión
                      </p>
                      <p className="text-sm text-foreground-600 leading-relaxed">{vision}</p>
                    </div>
                  )}
                </div>

                <div className="mt-8 flex items-center gap-3 relative">
                  <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500 text-background-50 font-bold">
                    MD
                  </span>
                  <div>
                    <p className="font-semibold text-foreground-950">{brand}</p>
                    <p className="text-sm text-foreground-500">{brandDescription}</p>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}